export function ShellInAuthenticationFlow() {
  return (
    <div className="min-h-screen bg-hc-bg flex flex-col font-sans">
      <nav className="bg-white border-b border-hc-border shadow-sm">
        <div className="flex items-center">
          <div className="bg-hc-green px-5 py-4">
            <img src="/static/hclogo.png" alt="Heidelberg Materials" className="h-8" />
          </div>
        </div>
      </nav>
      <div className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin h-10 w-10 border-4 border-hc-green border-t-transparent rounded-full mx-auto mb-4" />
          <p className="text-hc-text-grey">Signing in…</p>
        </div>
      </div>
    </div>
  );
}
